<template>
  <div>
    <div class="age-title">合计 <el-button type="text" size="small" @click="showUsed" v-if="usedId && usedId !== id">修改前审批通过数据</el-button></div>
    <el-table :data="[{}]" border>
      <el-table-column label="农龄份额">
        <el-table-column label="数量">
          <template>
            <el-input-number :precision="2" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0" style="width: 100%;" v-model="euFarmerStockEntity.farmerAgeQuantity"/>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="土地份额">
        <el-table-column label="数量">
          <template>
            <el-input-number :precision="2" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0" style="width: 100%;" v-model="euFarmerStockEntity.landQuantity"/>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template>
            <el-input-number :precision="2" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0" style="width: 100%;" v-model="euFarmerStockEntity.landAmount"/>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="人口份额">
        <el-table-column label="数量">
          <template>
            <el-input-number :precision="2" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0" style="width: 100%;" v-model="euFarmerStockEntity.populationQuantity"/>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template>
            <el-input-number :precision="2" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0" style="width: 100%;" v-model="euFarmerStockEntity.populationAmount"/>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="继承份额">
        <el-table-column label="数量">
          <template>
            <el-input-number :precision="2" disabled :controls="false" :min="0" style="width: 100%;" :value="getHeirNumber"/>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template>
            <el-input-number :precision="2" disabled :controls="false" :min="0" style="width: 100%;" :value="getHeirMoney"/>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="被继承份额">
        <el-table-column label="数量">
          <template>
            <el-input-number :precision="2" disabled :controls="false" :min="0" style="width: 100%;" :value="getInheritedsharesNumber"/>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template>
            <el-input-number :precision="2" disabled :controls="false" :min="0" style="width: 100%;" :value="getInheritedsharesMoney"/>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="其他份额">
        <el-table-column label="数量">
          <template>
            <el-input-number :precision="2" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0" style="width: 100%;" v-model="euFarmerStockEntity.otherQuantity"/>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template>
            <el-input-number :precision="2" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0" style="width: 100%;" v-model="euFarmerStockEntity.otherAmount"/>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="总份额" fixed="right" width="160px">
        <el-table-column label="数量">
          <template>
            <el-input-number :precision="2" disabled :controls="false" :min="0" style="width: 100%;" :value="getTotalNumber"/>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template>
            <el-input-number :precision="2" disabled :controls="false" :min="0" style="width: 100%;" :value="getTotalMoney"/>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <div class="age-title">
      <div>股份继承明细</div>
      <el-button type="text" size="small" @click="addAgeData" v-if="status !== 0 && InfoType !== 'details'">新增明细</el-button>
    </div>
    <div class="status-watermark-row">
      <div v-if="InfoType === 'details'" class="status-watermark" :style="{color: getType.color, 'border-color': getType.color}">{{getType.text}}</div>
      <el-table border :data="euFarmerStockHeritageEntityList" max-height="300">
        <el-table-column label="继承人">
          <template slot-scope="scope">
            <span>{{scope.row.farmerName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="被继承人">
          <template slot-scope="scope">
            <el-select
            placeholder="请选择"
            v-model="scope.row.inheritedFarmerNo"
            :disabled="status === 0 || InfoType === 'details' || scope.row.inheritedFarmerNo === getfarmer.id"
            @change="(value) => userChange(value, scope)">
              <el-option
               v-for="item in (scope.row.farmerNo === getfarmer.id ? getNocurrentFarmer : memberList)"
              :key="item.id"
              :value="item.id"
              :label="item.name"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="数量">
          <template slot-scope="scope">
            <el-input-number :controls="false" :precision="2" :disabled="status === 0 || InfoType === 'details' || scope.row.inheritedFarmerNo === getfarmer.id" :min="0" style="width: 100%;" v-model="scope.row.quantity"/>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            <el-input-number :controls="false" :precision="2" :disabled="status === 0 || InfoType === 'details' || scope.row.inheritedFarmerNo === getfarmer.id" :min="0" style="width: 100%;" v-model="scope.row.amount"/>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" :disabled="status === 0 || InfoType === 'details' || scope.row.inheritedFarmerNo === getfarmer.id" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="160"/>
        <el-table-column label="操作"  v-if="status !== 0 && InfoType !== 'details'">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="del(scope)"  v-if="scope.row.inheritedFarmerNo !== getfarmer.id">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 审批 -->
    <div class="age-title" v-if="status !== ''">审批信息</div>
    <el-form ref="form" :model="examineInfo" v-if="status === 0 && auditInfo.approvalFlag && InfoType !== 'details'">
      <el-form-item
      label="审核状态"
      label-width="80px"
      prop="status"
      :rules="{
        required: true, message: '请选择审核状态', trigger: 'change'
      }">
        <el-select v-model="examineInfo.status">
          <el-option value="1" label="通过"/>
          <el-option value="2" label="拒绝"/>
        </el-select>
      </el-form-item>
      <el-form-item
        label="审核原因"
        label-width="80px"
        >
          <el-input
          type="textarea"
          :rows="3"
          maxlength="200"
          placeholder="请输入审核原因"
          v-model="examineInfo.remark"/>
        </el-form-item>
    </el-form>
    <!-- 审批详情 -->
    <review-process
    :processList="auditInfo.auditProcessEntityList"
    :createTime="auditInfo.createTime"
    :createUser="auditInfo.applyUser"
    :auditPerson="auditInfo.auditPerson"
    />
    <div style="padding-top: 20px;text-align: center;" v-if="InfoType !== 'details'">
      <el-button  type="primary" @click="toExamine" v-if="status !== 0">提交审核</el-button>
      <el-button  type="primary" v-else-if="status === 0 && auditInfo.approvalFlag" @click="examine">提交审核</el-button>
      <el-button  type="primary" v-else @click="closeInfo">关闭</el-button>
    </div>
  </div>
</template>

<script>
import ReviewProcess from '@/components/ReviewProcess.vue'
import { euFarmerStockGetDetail, euFarmerInfoQuery, euFarmerStockSubmit, euFarmerStockAudit, listStockInherited } from '@/api/community.js'
export default {
  data () {
    return {
      euFarmerStockEntity: {
        farmerAgeQuantity: '',
        landQuantity: '',
        landAmount: '',
        populationQuantity: '',
        populationAmount: '',
        otherQuantity: '',
        otherAmount: ''
      },
      euFarmerStockHeritageEntityList: [],
      memberList: [],
      userInfo: {},
      examineInfo: {
        status: '',
        remark: ''
      },
      auditInfo: {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      },
      status: '',
      rderId: '',
      getfarmer: {}
    }
  },
  props: {
    id: { // 业务单id
      type: [String, Number],
      default: null
    },
    usedId: { // 上一次审批通过业务单id
      type: [String, Number],
      default: null
    },
    InfoType: {
      type: String,
      default: 'new'
    },
    farmerNo: {
      type: String,
      default: ''
    }
  },
  components: {
    ReviewProcess
  },
  computed: {
    // 被继承份额 - 金额
    getInheritedsharesMoney() {
      if (!this?.getfarmer?.id) return 0
      let decedentList = this.euFarmerStockHeritageEntityList.filter((item) => item.inheritedFarmerNo === this.getfarmer.id)
      let sum = decedentList.reduce((total, item) => total + item.amount, 0)
      return sum
    },
    // 被继承份额 - 数量
    getInheritedsharesNumber () {
       if (!this?.getfarmer?.id) return 0
      let decedentList = this.euFarmerStockHeritageEntityList.filter((item) => item.inheritedFarmerNo === this.getfarmer.id)
      let sum = decedentList.reduce((total, item) => total + item.quantity, 0)
      return sum
    },
    // 继承份额 - 金额
    getHeirMoney () {
      if (!this?.getfarmer?.id) return 0
      let heirList = this.euFarmerStockHeritageEntityList.filter((item) => item.farmerNo === this.getfarmer.id)
      let sum = heirList.reduce((total, item) => total + item.amount, 0)
      return sum
    },
    // 继承份额 - 数量
    getHeirNumber () {
      if (!this?.getfarmer?.id) return 0
      let heirList = this.euFarmerStockHeritageEntityList.filter((item) => item.farmerNo === this.getfarmer.id)
      let sum = heirList.reduce((total, item) => total + item.quantity, 0)
      return sum
    },
    // 合计-数量
    getTotalNumber () {
      const { farmerAgeQuantity = 0, landQuantity = 0, populationQuantity = 0, otherQuantity = 0 } = this.euFarmerStockEntity
      return farmerAgeQuantity + landQuantity + populationQuantity - this.getInheritedsharesNumber + this.getHeirNumber + otherQuantity
    },
    // 合计 - 金额
    getTotalMoney () {
      const { landAmount = 0, populationAmount = 0, otherAmount = 0 } = this.euFarmerStockEntity
      return landAmount + populationAmount - this.getInheritedsharesMoney + this.getHeirMoney + otherAmount
    },
    getType () {
      let status = this.status === -1 || this.status === '' ? 3 : this.status
      let json = {
        0: {
          text: '待审批',
          color: '#ff9800'
        },
        1: {
          text: '审批通过',
          color: '#27d92f'
        },
        2: {
          text: '审批拒绝',
          color: '#f44336'
        },
        3: {
          text: '待录入',
          color: 'rgb(149 149 150)'
        },
      }
      return json[status]
    },
    // 获取当前农民信息
    // getfarmer () {
    //   let userInfo = this.memberList.find((item) => item.id === this.farmerNo)
    //   return userInfo
    // },
    // 获取除当前农民之外的列表
    getNocurrentFarmer () {
      let list = this.memberList
      if (this.getfarmer.id) {
        list = list.filter((item) => item.id !== this.getfarmer.id)
      }
      return list
    }
  },
  mounted () {
    this.getMemberList()
    this.getfarmerInfo()
  },
  methods: {
    // 展示上一次审批记录
    showUsed () {
      this.$emit('showUsed', { type: 'share', id: this.usedId })
    },
    // 获取详情
    getData() {
      euFarmerStockGetDetail({
        eventId: this.id
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.orderId = result.id
          this.status = result.status
          this.euFarmerStockEntity = {
            farmerAgeQuantity: result?.farmerAgeQuantity || 0,
            landQuantity: result?.landQuantity || 0,
            landAmount: result?.landAmount || 0,
            populationQuantity: result?.populationQuantity || 0,
            populationAmount: result?.populationAmount || 0,
            otherQuantity: result?.otherQuantity || 0,
            otherAmount: result?.otherAmount || 0,
          }
          this.euFarmerStockHeritageEntityList = result.farmerStockHeritageEntityList || []
          this.auditInfo = {
            auditProcessEntityList: result.auditProcessEntityList,
            createTime: result.createTime,
            applyUser: result.applyUser,
            auditPerson: result.auditPerson,
            approvalFlag: true
          }
        }
      })
    },
    // 获取人员
    getMemberList () {
      listStockInherited({
        pageNum: 1,
        pageSize: 100
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.memberList = (result.records || []).map((item) => {
            return {
              name: item.farmerName,
              id: item.farmerNo
            }
          })
        }
      })
    },
    // 获取当前农民信息
    getfarmerInfo () {
      euFarmerInfoQuery({
        pageNum: 1,
        pageSize: 9999,
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          let userInfo = (result.records || []).find((item) => item.farmerNo === this.farmerNo)
          this.getfarmer = {
            name: userInfo.farmerName,
            id: userInfo.farmerNo
          }
        }
      })
    },
    // 新增继承详情
    addAgeData () {
      this.euFarmerStockHeritageEntityList.push({
        farmerName: this.getfarmer.name,
        farmerNo: this.getfarmer.id,
        inheritedFarmerName: '',
        inheritedFarmerNo: '',
        amount: '',
        quantity: '',
        createTime: '',
        remark: ''
      })
    },
    // 删除
    del (scope) {
      this.euFarmerStockHeritageEntityList.splice(scope.$index, 1)
    },
    // 修改被继承人
    userChange (value, scope) {
      let userInfo = this.memberList.find((item) => item.id === value)
      this.euFarmerStockHeritageEntityList[scope.$index].inheritedFarmerName = userInfo.name
    },
    // 提交审核
    toExamine () {
      let euFarmerStockHeritageEntityList = this.euFarmerStockHeritageEntityList.filter((item) => item.inheritedFarmerNo !== this.farmerNo)
      euFarmerStockSubmit({
        euFarmerStockEntity: {
          ...this.euFarmerStockEntity,
          inheritAmount: this.getHeirMoney,
          inheritQuantity: this.getHeirNumber,
          totalAmount: this.getTotalMoney,
          totalQuantity: this.getTotalNumber,
          eventId: this.id,
          farmerNo: this.getfarmer.id,
          farmerName: this.getfarmer.name
        },
        euFarmerStockHeritageEntityList
      }).then(res => {
        const { code } = res
        if (code === 0) {
          this.$emit('closeInfo', true)
        }
      })
    },
    // 关闭
    closeInfo () {
      this.$emit('closeInfo')
    },
    // 审核
    examine () {
      this.$refs.form.validate((vaild) => {
        if (vaild) {
          euFarmerStockAudit({
            id: this.orderId,
            ...this.examineInfo,
          }).then(res => {
            if (res.code === 0) {
              this.$emit('closeInfo', true)
            }
          })
        }
      })
    }
  },
  watch: {
    id: {
      handler() {
        if (this.id) {
          this.getData()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.age-title {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
}
.status-watermark-row {
  position: relative;
  .status-watermark{
    position: absolute;
    right: -20px;
    top: -30px;
    height: 100px;
    width: 100px;
    border-radius: 50px;
    border: 2px dashed;
    text-align: center;
    line-height: 100px;
    z-index: 1;
    transform:rotate(-30deg);
    font-weight: 600;
  }
}
</style>